<template>

  <div>
    <div class="container">
  
      <div class="tool-header">
        <div class="site-name">{{ site.name }}</div>
        <div class="tool-title">
          Add keywords to get instant SEO insights
          <span class="material-icons video-tutorial-icon video-tutorial-icon-size"
            @click="() => {
              $store.commit('setCurrentVideoTutorialToDisplay', {
                title: 'How to Use the Keyword Insight Tool',
                videoLink: 'https://www.youtube.com/embed/sEKr_Zwi49w',
                description: 'In this video, you\'ll get a step-by-step walkthrough of how to use POP\'s Keyword Insight tool. This tool allows you to analyze an existing list of up to 100 keywords in one click using new POP metrics making it easy to identify those hidden gems.',
                time: '3m 43s'
              });
            }">
            videocam
          </span>
        </div>
        <div class="tool-description">Analyze up to 100 keywords with SEO metrics and AI to spot top-ranking opportunities.</div>
      </div>
  
    </div>
  
    <div class="container">
  
      <div class="white-common-box p-5" style="overflow-x: initial;">
  
        <form-section
          :reloadUser="reloadUser"
          :site="site"
          :campaign="campaign"
          :hasUnlimitedAccess="hasUnlimitedAccess"
          :isWhiteGloveUser="isWhiteGloveUser"
          :isMissionControlSession="isMissionControlSession"
          :isContentOnlyView="isContentOnlyView"
        />
  
      </div>
  
    </div>
  
    <hr style="background-color: var(--v-gray12Color-base); height: 1px; margin: 3rem 0;" />

    <div class="container">
      <list-section
        :reloadUser="reloadUser"
        :site="site"
        :campaign="campaign"
        :hasUnlimitedAccess="hasUnlimitedAccess"
        :isWhiteGloveUser="isWhiteGloveUser"
        :isMissionControlSession="isMissionControlSession"
        :isContentOnlyView="isContentOnlyView"
      />
    </div>

    <hr style="background-color: var(--v-gray12Color-base); height: 1px; margin: 3rem 0;" />
  
    <div class="container">
  
      <div
        class="white-common-box d-flex"
        style="padding: 60px 42px; gap: 28px;"
      >
  
        <div style="flex: 1; text-align: center;">
          <img src="/static/keyword-insight-image.png" style="width: 450px;">
        </div>
  
        <div style="flex: 1;">
          <div style="max-width: 450px;">
            <div
              class="mb-6 mt-4"
              style="font-size: 1.4rem; font-weight: 800; line-height: 1.6;"
            >Discover high-impact keywords fast</div>
            <div
              class="mb-6"
              style="font-size: 1.1rem; line-height: 1.6;"
            >Uncover keyword opportunities with real SEO power. Get instant insights like difficulty, trends, and AI-powered content silo suggestions, all ranked by POP’s proprietary Keyword Score and SEO Competitiveness Index.</div>
            <v-btn color="#00C362"
              class="whiteColor--text text-none font-weight-bold"
              large
              target="_blank"
              href="https://help.pageoptimizer.pro/article/keyword-insight-tool"
            >
              Learn how to use Keyword insight
            </v-btn>
          </div>
        </div>
  
      </div>
      
    </div>

  </div>

</template>

<script>
import FormSection from './FormSection.vue'
import ListSection from './ListSection.vue'

export default {
  props: ['site', 'campaign', 'hasUnlimitedAccess', 'isWhiteGloveUser', 'isMissionControlSession', 'reloadUser'],
  components: {
    FormSection,
    ListSection,
  },
  data () {
    return {
      
    }
  },
  computed: {
    isContentOnlyView () {
      return Boolean(this.$route.query.fromQuickContentOrdersTab)
    },
  },
  watch: {
    
  },
  methods: {
    
  },
  mounted () {
    
  }
}
</script>

<style lang="scss" scoped>
@import "./../styles.scss";
</style>